"use client";

import { HeartIcon } from "@heroicons/react/24/outline";

import { Spinner } from "@/components/ui/spinner";
import { Button, type ButtonProps } from "@/components/ui/button";

import { usePostFavorite } from "@/queries/mutations/use-post-favorite";

import { cn } from "@/lib/utils";

import type { House } from "@/types";

interface Props
  extends Omit<ButtonProps, "id">,
    Pick<House, "id" | "favorito"> {
  addLabel?: string;
  removeLabel?: string;
  fullWidth?: boolean;
}

export const FavoriteButton = ({
  id,
  favorito,
  addLabel = "Favoritar",
  removeLabel = "Remover dos favoritos",
  fullWidth,
  ...props
}: Props) => {
  const { save, isPending, isFavorite } = usePostFavorite({
    initialFavorite: favorito,
    revalidateMainListPath: true,
  });
  const text = isFavorite ? removeLabel : addLabel;

  return (
    <Button
      variant="secondary"
      disabled={isPending}
      size="sm"
      aria-label={text}
      onClick={() => save(id)}
      {...props}
    >
      {isPending ? (
        <Spinner />
      ) : (
        <>
          <HeartIcon
            aria-hidden="true"
            className={`w-4 h-4 ${
              isFavorite ? "text-red-500 fill-current" : ""
            }`}
          />
          <span className={cn(fullWidth ? "ml-2" : "sm:ml-2 hidden sm:block")}>
            {text}
          </span>
        </>
      )}
    </Button>
  );
};
